<template>
  <FieldView
    :class="`form-checkbox m-t-10 ${this.customClass}`"
    :data-e2e="FormCypressAttribute.views.CHECKBOX_FIELD"
  >
    <ValidationProvider
      ref="validationProvider"
      :rules="customRules"
      :name="formattedLabel"
      :value="computedValue"
    >
      <TooltipView
        :active="tooltipActive"
        :type="tooltipType"
        :label="tooltipLabel"
        :position="tooltipPosition"
        :multilined="tooltipMultilined"
        :size="tooltipSize"
      >
        <CheckboxView
          :class="checkboxClass"
          v-model="computedValue"
          :disabled="readOnly"
          :size="size"
          :data-e2e="FormCypressAttribute.views.CHECKBOX"
          @input="onInput"
        >
          <slot>
            <span>{{ formattedLabel }}</span>
          </slot>
        </CheckboxView>
      </TooltipView>
    </ValidationProvider>
  </FieldView>
</template>

<script>
import ValidationProvider from '/@/modules/core/form/components/ValidationProvider.vue';
import { FormInputMixin } from '/@/modules/core/form/mixins/FormInputMixin';
import { FormCypressAttribute } from '/@/modules/core/form/constants/FormCypressAttribute';
import { FormValidationMixin } from '/@/modules/core/form/mixins/FormValidationMixin';
import { FormInputTooltipMixin } from '/@/modules/core/form/mixins/FormInputTooltipMixin';
import { FormCheckboxMixin } from '@/modules/core/form/mixins/FormCheckboxMixin';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';
import FieldView from '@/modules/core/ui/components/wrappers/FieldView.vue';
import CheckboxView from '@/modules/core/ui/components/wrappers/CheckboxView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FormCheckbox',
  emits: ['select'],
  mixins: [FormCheckboxMixin, FormInputMixin, FormValidationMixin, FormInputTooltipMixin],
  components: { CheckboxView, FieldView, TooltipView, ValidationProvider },
  static: {
    FormCypressAttribute
  },
  computed: {
    customClass() {
      return this.readOnly ? 'is-readonly' : '';
    },
    customRules() {
      if (!this.rules) {
        return null;
      }

      /* eslint-disable prefer-destructuring */
      const rules = this.rules;

      if (rules.required) {
        rules.required = { allowFalse: false };
      }

      return rules;
    }
  },
  methods: {
    onInput(value) {
      this.$emit('select', value);
    }
  }
};
</script>

<style scoped>
.form-checkbox :deep(.tooltip-trigger) {
  display: flex;
}

.form-checkbox.is-readonly :deep(.b-tooltip .tooltip-content) {
  top: var(--ce-10px);
}

.form-checkbox.is-readonly :deep(.b-checkbox.checkbox[disabled]) {
  opacity: 1 !important;
}

.form-checkbox.is-readonly :deep(.b-checkbox.checkbox[disabled] .check) {
  opacity: 0.5 !important;
  margin-top: var(--ce-2px);
}

.form-checkbox.is-readonly :deep(.b-checkbox.checkbox[disabled] span.control-label span) {
  color: var(--ce-black);
}
</style>
